<template>
	<v-card class="shadowCard">
	  <aside class="responsive-banner">
	    <span class="circle-a"></span>
	    <span class="circle-b"></span>
	    <div class="container-envelope">
	      <div class="col-xs-12">
	        <p class="text-body-1">{{ avisoDescuento.aviso.nota }}</p>
	        <!-- <a target="_blank" :href="avisoDescuento.aviso.ruta_pago" class="more-link">¡PAGA AQUÍ!</a> -->
          <a class="more-link" @click="alertaVideoDescuento.estatus = true">Ver más</a>
	      </div>
	    </div>
	  </aside>

    <VideoDescuento   v-if="alertaVideoDescuento.estatus"  :alertaVideoDescuento="alertaVideoDescuento" @click="salirLogin()"/>
	</v-card>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
	import { Clipboard } from '@capacitor/clipboard';
  // import { Share } from '@capacitor/share';

  import VideoDescuento  from '@/components/avisos/VideoDescuento.vue'


	export default {
    components:{
      VideoDescuento
    },

    data () {
      return {
        alertaVideoDescuento:{
          estatus: false,
          ruta_pago:''
        },
      }
    },

		props:[
			'avisoDescuento'
	  ],

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    created(){
      this.alertaVideoDescuento.ruta_pago = this.avisoDescuento.aviso.ruta_pago
    },

    methods:{
      async copiarPortapapeles( ){
        const matricula = this.getUsuarioLMS.usuario
        let   mensaje   = ''

        if( this.getEscuela == 2 ){
          mensaje = 'https://wa.me/+5218120494796?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }else{
          mensaje = 'https://wa.me/+5218120474412?text=Hola,+me+interesa+aprovechar+el+descuento+especial+para+estudiar+inglés.+Me+recomendó+el+alumno+con+matricula+'+matricula
        }

        Clipboard.write({
          string: mensaje
        });

        await Share.share({
          title: 'Comparte y gana',
          text: 'Comparte este enlace con todos tus amigos',
          url: mensaje,
          dialogTitle: 'Compartir enlace',
        });

      }
    }
  }
</script>

<style scoped>

  /* STYLE FOR AVISO PAGO  */
  .responsive-banner {
    min-width: 230px;
    position: relative;
    height: auto;
    border-radius: 10px;
    overflow: hidden;
    background-image: linear-gradient(to bottom right, #5BC2D4, #84D9E0);
    background-repeat: no-repeat;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .container-envelope {
    padding: 35px 15px;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .col-xs-12 {
    text-align: center;
  }

  img {
    width: 100%;
    position: relative;
  }

  span:after,
  span:before {
    content: "";
    position: absolute;
    display: block;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    width: 50px;
    height: 50px;
  }

  .circle-a:before {
    width: 500px;
    height: 500px;
    top: -300px; left: 52%;
    -webkit-transform: translate(-50%,0);
    -ms-transform: translate(-50%,0);
    transform: translate(-50%,0);
  }

  .circle-a:after {
    top: 160px;
    right: 10%;
  }

  .circle-b:before {
    top: 60%;
    left: -25px;
  }

  .circle-b:after {
    width: 150px;
    height: 150px;
    bottom: -70px;
    right: -70px;
  }

  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }

</style>